import api from '@/helpers/api'

/**
 * ExtranetMerchant Store Module
 * 
 * Manages merchant data in extranet context.
 * Hits /api/extranet/merchants endpoints.
 * X-Tenant-Domain header is automatically injected by api.js.
 */
const state = {
  merchants: [],
  meta: {
    page: 1,
    limit: 10,
    total: 1,
    sortBy: '',
    sortAsc: true
  },
  filter: {},
  search: {}
}

const mutations = {
  read(state, payload) {
    state.merchants = payload.data_res || []
    state.meta = payload.meta || state.meta
    state.filter = payload.filter || {}
    state.search = payload.search || {}
  },

  switch_page(state, payload) {
    state.meta = payload.meta
  },

  add_filter(state, payload) {
    state.filter = { ...state.filter, ...payload.filter }
  },

  set_search(state, payload) {
    state.search = payload.search
  },

  clear_search(state) {
    state.search = {}
  }
}

const actions = {
  /**
   * Read merchants from extranet API
   */
  async read({ state, commit }) {
    try {
      const params = {
        custom: {
          page: state.meta.page,
          per_page: state.meta.limit,
          ...state.filter,
          ...state.search
        }
      }

      const response = await api.request('get', '/api/extranet/merchants', params)

      const responseData = response.data.data || response.data
      commit('read', responseData)

      return responseData
    } catch (error) {
      console.error('[ExtranetMerchant Store] Error reading merchants:', error)
      throw error
    }
  },

  /**
   * Read single merchant by ID
   */
  async read_single(context, id) {
    try {
      const response = await api.request('get', `/api/extranet/merchants/${id}`)
      return response.data.data || response.data
    } catch (error) {
      console.error('[ExtranetMerchant Store] Error reading merchant:', error)
      throw error
    }
  },

  /**
   * Create new merchant
   */
  async create(context, payload) {
    try {
      const response = await api.request('post', '/api/extranet/merchants', {}, payload.data)
      return response.data.data || response.data
    } catch (error) {
      console.error('[ExtranetMerchant Store] Error creating merchant:', error)
      throw error
    }
  },

  /**
   * Update existing merchant
   */
  async update(context, payload) {
    try {
      const response = await api.request('put', `/api/extranet/merchants/${payload.data.id}`, {}, payload.data)
      return response.data.data || response.data
    } catch (error) {
      console.error('[ExtranetMerchant Store] Error updating merchant:', error)
      throw error
    }
  },

  /**
   * Delete merchant
   */
  async delete(context, id) {
    try {
      const response = await api.request('delete', `/api/extranet/merchants/${id}`)
      return response.data
    } catch (error) {
      console.error('[ExtranetMerchant Store] Error deleting merchant:', error)
      throw error
    }
  }
}

const getters = {
  merchants: state => state.merchants,
  meta: state => state.meta,
  filter: state => state.filter,
  search: state => state.search
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
